import { Tag } from '@chakra-ui/react'
import { EStatus } from 'constants/workplan'

interface IStateBadgeProps {
  status: EStatus | number
  /** Opt-in dark-surface palette (default light). Set on dark pages. */
  variant?: 'light' | 'dark'
}

const StateBadge = ({ status, variant = 'light' }: IStateBadgeProps) => {
  const normalized = Number(status)
  const getBadgeColors = (s: number) => {
    if (variant === 'dark') {
      // Translucent fills + brighter text/border so the tag reads cleanly on the
      // dark surface instead of the light pastel pill.
      return s === EStatus.ACTIVE
        ? { backgroundColor: 'rgba(46, 143, 204, 0.16)', borderColor: 'rgba(127, 181, 255, 0.45)', textColor: '#7FB5FF' }
        : { backgroundColor: 'rgba(230, 126, 34, 0.16)', borderColor: 'rgba(255, 179, 102, 0.45)', textColor: '#FFB366' }
    }
    if (s === EStatus.ACTIVE) {
      return {
        backgroundColor: '#E6F3FF',
        borderColor: '#4A90E2',
        textColor: '#2E5BBA'
      }
    }
    return {
      backgroundColor: '#FFF7E6',
      borderColor: '#FFB366',
      textColor: '#E67E22'
    }
  }

  const colors = getBadgeColors(normalized)

  return (
    <Tag
      size="md"
      variant="outline"
      borderRadius="6px"
      px={2}
      py={1}
      fontSize="14px"
      fontWeight={600}
      borderWidth="1px"
      backgroundColor={colors.backgroundColor}
      borderColor={colors.borderColor}
      color={colors.textColor}
      shadow="none"
    >
      {normalized === EStatus.ACTIVE ? 'Active' : 'Inactive'}
    </Tag>
  )
}

export default StateBadge
